// import { CommentIcon } from '@components/Icons/CommentIcon.';
// import { FavoriteIcon } from '@components/Icons/FavoriteIcon';
// import { OptionsIcon } from '@components/Icons/OptionsIcon';
import { PlayIcon } from '@components/Icons/PlayIcon';
import { RightArrowIcon2 } from '@components/Icons/RightArrowIcon2';
// import { SavedIcon } from '@components/Icons/SavedIcon';
import { useMusicState } from '@hooks/storeHooks/useMusicState';

export const FeedPlaylistTrack = () => {
  const { setActivePlaylist } = useMusicState();
  const album = {
    id: 'f517937d-ec8a-4c87-8623-ed57769dc6a7',
    upc: '666190300160',
    pk: '',
    albumName: 'Exam Ease',
    albumArtUrl:
      'https://napstermusicstoragedev.blob.core.windows.net/music/contributors/9170120d-2062-45d9-b928-bf19a51bfbd0/albums/f517937d-ec8a-4c87-8623-ed57769dc6a7/f517937d-ec8a-4c87-8623-ed57769dc6a7.jpg',
    description: 'Drift away with gentle tones and soft rhythms.',
    category: 'serenity',
    genre: ['mindfulness'],
    tracks: [
      {
        id: 'b7b3cde6-e970-49e0-ba38-95951b9c2dae',
        name: 'Pre‑Study Prime',
        url: 'https://napstermusicstoragedev.blob.core.windows.net/music/contributors/9170120d-2062-45d9-b928-bf19a51bfbd0/albums/f517937d-ec8a-4c87-8623-ed57769dc6a7/tracks/b7b3cde6-e970-49e0-ba38-95951b9c2dae/b7b3cde6-e970-49e0-ba38-95951b9c2dae',
        duration: 0,
      },
    ],
    contributors: [
      {
        id: '9170120d-2062-45d9-b928-bf19a51bfbd0',
        givenName: "Liam O'Connell",
        thumbnailUrl:
          'https://napstermusicstoragedev.blob.core.windows.net/music/contributors/9170120d-2062-45d9-b928-bf19a51bfbd0/9170120d-2062-45d9-b928-bf19a51bfbd0.jpg',
        videoDesktopUrl:
          'https://napstermusicstoragedev.blob.core.windows.net/music/contributors/9170120d-2062-45d9-b928-bf19a51bfbd0/9170120d-2062-45d9-b928-bf19a51bfbd0_desktop.mp4',
        videoMobileUrl:
          'https://napstermusicstoragedev.blob.core.windows.net/music/contributors/9170120d-2062-45d9-b928-bf19a51bfbd0/9170120d-2062-45d9-b928-bf19a51bfbd0_mobile.mp4',
      },
    ],
    likes: 672,
    type: 'Album',
    isLiked: false,
  };
  const playMusic = () => {
    const playlist = {
      currentIndex: 0,
      album: album,
    };
    setActivePlaylist(playlist);
  };
  return (
    <div className="w-full bg-[linear-gradient(180deg,rgba(255,44,131,0.2)_0%,rgba(255,44,131,0)_100%)] rounded-[16px] pb-[16px] font-[NapsterSans]">
      <div className="flex p-4 w-full gap-2 items-center">
        <div className="flex w-[36px] h-[36px]">
          <img
            className="w-full h-full object-fit-cover"
            src="/assets/images/logged_user.png"
            alt="User"
          />
        </div>
        <div className="flex flex-col flex-1 font-[NapsterSans]">
          <div className="flex text-[14px] font-semibold leading-[130%] text-left text-white pb-[2px]">
            Liam O'Connell
          </div>
          <div className="flex gap-[5px] items-center">
            <div className="flex text-[12px] font-normal leading-[130%] text-left text-white/60 pb-[2px]">
              @liam
            </div>
            <div className="flex text-[12px] font-normal leading-[130%] text-left text-white/60">
              • now
            </div>
            <div className="flex">
              {' '}
              <button className="text-[8px] font-normal leading-[130%] text-left text-white/60 border border-white/20 p-[3px] rounded-[4px]">
                playlist
              </button>
            </div>
          </div>
        </div>
        <div className="flex">{/* <OptionsIcon /> */}</div>
      </div>

      <div className="w-full p-4 pt-[0] text-[14px] font-normal leading-[130%] text-left text-white font-[NapsterSans]">
        Loving this new release from{' '}
        <a
          onClick={playMusic}
          href="#"
          className="w-full text-[14px] font-normal leading-[130%] text-left text-[#0FF]">
          Liam O'Connell
        </a>{' '}
        Drift away with gentle tones and soft rhythms.
      </div>

      <div className="flex w-full relative px-4 pb-4">
        <div className="flex pt-[12px] pb-[12px] w-full px-3 gap-[12px] items-center shadow-[0_4px_32px_0_rgba(0,0,0,0.40)] bg-[rgba(252,252,252,0.10)] rounded-[8px]">
          <div className="flex">
            <div className="flex relative shadow-[0_4px_16px_0_rgba(0,0,0,0.40)] rounded-[8px] overflow-hidden">
              <img
                className="w-[56px] h-[56px] object-fit-cover overflow-hiddden"
                src="https://napstermusicstoragedev.blob.core.windows.net/music/contributors/9170120d-2062-45d9-b928-bf19a51bfbd0/albums/f517937d-ec8a-4c87-8623-ed57769dc6a7/f517937d-ec8a-4c87-8623-ed57769dc6a7.jpg"
                alt="Feed"
              />
              <div className="w-[40px] h-[40px] absolute flex items-center justify-center bg-[rgba(0,0,0,0.2)] top-0 bottom-0 left-0 right-0 m-auto">
                <a
                  onClick={playMusic}
                  href="#"
                  className="w-full text-[14px] font-normal leading-[130%] text-left text-[#0FF]">
                  <PlayIcon width={34} height={34} />
                </a>
              </div>
            </div>
          </div>
          <div className="flex flex-col flex-1">
            <div className="flex text-sm font-bold leading-[130%] text-left text-white pb-1">
              Exam Ease
            </div>
            <div className="flex text-xs font-medium leading-[130%] text-left text-white/80">
              Liam O'Connell
            </div>
          </div>
          <div className="w-[40px] h-[40px] flex items-center justify-center bg-[rgba(0,0,0,0.2)] rounded-full">
            <RightArrowIcon2 width={21} height={20} />
          </div>
        </div>
      </div>

      {/* <div className="flex w-full gap-[4px] relative z-[1] pt-4 px-4">
        <button className="flex items-center gap-[4px] h-[28px] border-1 border-white/20 w-fit px-3 rounded-full">
          <FavoriteIcon width={16} height={16} fillOpacity={0.8} />
          <span className="text-[10px] font-normal leading-[140%] text-white text-left">
            4.1K
          </span>
        </button>

        <button className="flex items-center gap-[4px] h-[28px] border-1 border-white/20 w-fit px-3 rounded-full">
          <CommentIcon />
          <span className="text-[10px] font-normal leading-[140%] text-white text-left">
            4.1K
          </span>
        </button>

        <button className="flex items-center gap-[4px] h-[28px] border-1 border-white/20 w-fit px-3 rounded-full">
          <SavedIcon />
          <span className="text-[10px] font-normal leading-[140%] text-white text-left">
            4.1K
          </span>
        </button>
      </div> */}
    </div>
  );
};
